import Utils from '../HlsUtils';
import AESDecryptor from './js-aes-decryptor';
//import type from 'type-detect';

class JsCryptoWrapper {

	constructor() {
		this.crypto = new AESDecryptor();
	}

	_importKeyCheck( format, keyData, algo, extractable, usages ) { // eslint-disable-line no-unused-vars
		if( format !== 'raw' ) {
			throw new Error(`JsCryptoWrapper.importKey only supports raw keys : ${format}`);
		}

		if( algo.name !== 'AES-CBC' ) {
			throw new Error(`JsCryptoWrapper.importKey only supports AES-CBC algorithm : ${algo}`);
		}

		if( keyData.length !== 16 ) {
			throw new Error(`JsCryptoWrapper.importKey key is not a valid length : ${keyData.length}`);
		}
	}

	importKey( format, keyData, algo, extractable, usages ) {
		return new Promise((resolve, reject) => {
			try {
				this._importKeyCheck( format, keyData, algo, extractable, usages ); // throws

				// Each key has its own AESDecryptor, because each AESDecryptor has its own key.
				let aesKey = this.crypto.expandKey(keyData);

				let cryptoKey = { aesKey, algo };
				if( extractable ) {
					cryptoKey.key = keyData;
				}


				// the key contains a field for the crypto instance, with the key loaded.
				resolve( cryptoKey );
			}
			catch(err) {
				reject(err);
			}
		});
	}

	_decryptCheck( algo, key, data ) {
		if( !Utils.isObject(key.aesKey) || !Utils.isObject(key.algo)) {
			throw new Error( `JsCryptoWrapper.decrypt, key is not valid : ${key}`);
		}

		if( key.algo.name !== algo.name ) {
			throw new Error( `JsCryptoWrapper.decrypt, algorithm doesn't match key : ${algo}`);
		}

		if( !Utils.isObject(algo.iv) ) {
			throw new Error( `JsCryptoWrapper.decrypt, IV invalid : ${algo.iv}`);
		}

		if( algo.iv.length !== 16 ) {
			throw new Error( `JsCryptoWrapper.decrypt, IV length invalid : ${algo.iv.length}`);
		}

		if( data.length % 16 !== 0 ) {
			throw new Error( `JsCryptoWrapper.decrypt, data is not a multiple of 16 : ${data.length}`);
		}

	}

	decrypt( algo, key, data ) {

		let result = new Promise((resolve, reject) => {

			try {
				this._decryptCheck( algo, key, data ); // throws

				let decrypted = this.crypto.decrypt( key.aesKey, data, algo.iv);
				resolve(decrypted);
			}
			catch(err) {
				reject(err);
			}
		});

		return result;
	}
}

export default JsCryptoWrapper;



// WEBPACK FOOTER //
// ./src/aes/JsCryptoWrapper.js